/** The build's package.json version. Callers never supply this. */
export function appVersion(): string {
  return __APP_VERSION__;
}
